import * as tslib_1 from "tslib";
import RegionalFull from './view/RegionalFull';
import RegionalQuick from './view/RegionalQuick';
import isRegionalOptionDirty from './utils/isRegionalOptionDirty';
import * as React from 'react';
import discardRegionalOption from './data/mutators/discardRegionalOption';
import saveRegionalOption from './orchestration/saveRegionalOption';
var RegionalOption = {
    key: 'regional',
    titleStringKey: 'optionTitle_regional',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_regional',
    fullOptionFormSettings: {
        render: function () { return React.createElement(RegionalFull, null); },
        isDirty: isRegionalOptionDirty,
        onSave: saveRegionalOption,
        onDiscard: discardRegionalOption,
    },
    quickOptionSettings: {
        rendering: {
            render: function (props) { return React.createElement(RegionalQuick, tslib_1.__assign({}, props)); },
        },
        order: 10 /* RegionalSettings */,
        workloads: 2 /* Calendar */,
        customTitle: 'optionTitle_regionalQuick',
    },
};
export default RegionalOption;
//# sourceMappingURL=RegionalOption.js.map